// ==============================|| OVERRIDES - LIST ITEM BUTTON ||============================== //

export default function ListItemButton(theme) {
	return {
		MuiListItemButton: {
			styleOverrides: {
				root: {}
			}
		}
	}
}
